// extracted by mini-css-extract-plugin
export default {"foot":"footerfoot_foot__e4tdY"};